<script>
    import { store } from '../../Store.svelte';

    export let item = {};
    let cantidad = 0;
    let minusDisabled = 'selector--disabled';
    let plusDisabled = '';
    let producto = '';

    store.subscribe((value) => {
        cantidad = 0;
        minusDisabled = 'selector--disabled';
        producto = $store.requestedServices.product.productFamily;
        $store.requestedServices.phoneExtensionsExtras.forEach((extra) => {
            if (
                extra.extId == item.extId &&
                (producto == 'izzinegocios_3P' || producto == 'izzinegocios')
            ) {
                cantidad = extra.nuevaCantidad;
                if (extra.nuevaCantidad > 0) {
                    minusDisabled = '';
                }
                if (extra.nuevaCantidad == item.paqextMaximo - 1) {
                    plusDisabled = 'selector--disabled';
                } else {
                    plusDisabled = '';
                }
            } else if (extra.extId == item.extId) {
                cantidad = extra.nuevaCantidad;
                if (extra.nuevaCantidad > 0) {
                    minusDisabled = '';
                }
                if (extra.nuevaCantidad == item.paqextMaximo) {
                    plusDisabled = 'selector--disabled';
                } else {
                    plusDisabled = '';
                }
            }
        });
    });

    function remove() {
        changeQuantity(false);
    }

    function add() {
        changeQuantity(true);
    }

    function remove_neg() {
        changeQuantity_neg(false);
    }

    function add_neg() {
        changeQuantity_neg(true);
    }

    function changeQuantity(add) {
        let selectedExtras = $store.requestedServices.phoneExtensionsExtras;
        let found = false;
        selectedExtras.forEach((extra) => {
            if (extra.extId == item.extId) {
                found = true;
                if (add && extra.nuevaCantidad < item.paqextMaximo) {
                    extra.nuevaCantidad += 2;
                } else if (!add) {
                    if (extra.nuevaCantidad > 1) {
                        extra.nuevaCantidad -= 2;
                    } else {
                        selectedExtras =
                            selectedExtras.filter(removeCurrentExtra);
                    }
                }
            }
        });
        if (!found) {
            selectedExtras.push({
                extId: item.extId,
                nuevaCantidad: 1,
                extra: {
                    title: item.extra.title,
                    cost: item.extra.cost,
                    extName: item.extra.extName,
                },
            });
        }
        $store.requestedServices.phoneExtensionsExtras = selectedExtras;
    }

    function changeQuantity_neg(add) {
        let selectedExtras = $store.requestedServices.phoneExtensionsExtras;
        let found = false;
        selectedExtras.forEach((extra) => {
            if (extra.extId == item.extId) {
                found = true;
                if (add && extra.nuevaCantidad < item.paqextMaximo - 1) {
                    extra.nuevaCantidad += 2;
                } else if (!add) {
                    if (extra.nuevaCantidad > 1) {
                        extra.nuevaCantidad -= 2;
                    } else {
                        selectedExtras =
                            selectedExtras.filter(removeCurrentExtra);
                    }
                }
            }
        });
        if (!found) {
            selectedExtras.push({
                extId: item.extId,
                nuevaCantidad: 2,
                extra: {
                    title: item.extra.title,
                    cost: item.extra.cost,
                    extName: item.extra.extName,
                },
            });
        }
        $store.requestedServices.phoneExtensionsExtras = selectedExtras;
    }

    function removeCurrentExtra(extra) {
        return extra.extId != item.extId;
    }

    var ga4ID = `${item.extra.title.toLowerCase().replace(" ", "-")}-ga4`
</script>

<div class="pure-u-1 pure-u-md-1-2">
    <div class="panel panel--lightgray text-center">
        <p class="fw-semibold m-b-10">{item.extra.title}</p>
        <div class="quantity-selectors m-b-15">
            {#if producto == 'izzinegocios_3P' || producto == 'izzinegocios'}
                <button
                    type="button"
                    on:click={remove_neg}
                    class="selector selector--minus {minusDisabled}"
                    ><span>-</span></button
                >
                <span class="quantity-num">{cantidad}</span>
                <button
                    type="button"
                    on:click={add_neg}
                    class="selector selector--plus {plusDisabled}"
                    ><span>+</span></button
                >
                <input type="hidden" bind:value={cantidad} />
            {:else}
                <button
                    type="button"
                    on:click={remove}
                    class="selector selector--minus {minusDisabled}"
                    id="minus-{ga4ID}"
                    ><span>-</span></button
                >
                <span class="quantity-num">{cantidad}</span>
                <button
                    type="button"
                    on:click={add}
                    class="selector selector--plus {plusDisabled}"
                    id="plus-{ga4ID}"
                    ><span>+</span></button
                >
                <input type="hidden" bind:value={cantidad} />
            {/if}
        </div>
        <div class="h2 text-fs-23 fw-semibold primary-text m-b-10">
            +$<span>{item.extra.cost}</span>
        </div>
        <p class="m-b-0">Cada uno / Pago único</p>
    </div>
</div>
